import { render, staticRenderFns } from "./comTypeForm.vue?vue&type=template&id=5c52f288&scoped=true"
import script from "./comTypeForm.vue?vue&type=script&lang=js"
export * from "./comTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52f288",
  null
  
)

export default component.exports